import { navigateService } from '../shared/services/navigate/navigate.service';

export function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((registration) => {
        // Force update check
        registration.update();
        // Check for updates on navigation
        navigateService.sub.state().subscribe(() => {
          registration.update();
        });

        // Handle immediate activation of new service worker
        registration.onupdatefound = () => {
          const newSW = registration.installing;
          if (newSW) {
            newSW.onstatechange = () => {
              if (newSW.state === 'installed' && navigator.serviceWorker.controller) {
                newSW.postMessage({ type: 'SKIP_WAITING' });
              }
            };
          }
        };
      })
      .catch((error) => {
        console.error('ServiceWorker registration failed:', error);
      });
  }
}
